"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentType = void 0;
var DocumentType;
(function (DocumentType) {
    DocumentType["INVOICE"] = "INVOICE";
    DocumentType["RECEIPT"] = "RECEIPT";
    DocumentType["CREDIT_NOTE"] = "CREDIT_NOTE";
    DocumentType["STATEMENT"] = "STATEMENT";
    DocumentType["TAX_INVOICE"] = "TAX_INVOICE";
})(DocumentType || (exports.DocumentType = DocumentType = {}));
